import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=83489ebc&"
import script from "./concept.vue?vue&type=script&lang=js&"
export * from "./concept.vue?vue&type=script&lang=js&"
import style0 from "./concept.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports